module.exports = __webpack_public_path__ + "img/group_1.fab25073.png";